import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'

import Skeleton from 'components/CarSettings/Common/Creation/Summary/Skeleton'
import TranslationItem from 'components/CarSettings/Common/Creation/Summary/TranslationItem'
import SummaryItem from 'components/Common/SummaryItem'

import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { FuelTypeCreationProps } from 'utils/CarSettings/FuelType/creation'

import { SectionContainer } from 'styles/creation'

const Summary = ({
  handleBack,
  fuelTypeData,
  handleSubmit,
  submitLoading,
}: FuelTypeCreationProps) => {
  const { text: generalText } = useTranslation(textFiles.GENERAL)
  const { text } = useTranslation(textFiles.FUEL_TYPE_CREATION)
  const { summary } = text
  const { fuelTypeInformation } = fuelTypeData
  const { translations } = fuelTypeInformation

  return (
    <Skeleton
      previousFunction={handleBack}
      nextFunction={handleSubmit}
      title={summary.title}
      description={summary.description}
      submitLoading={submitLoading}
    >
      <SectionContainer>
        <SummaryItem
          title={summary.name}
          text={fuelTypeInformation.name}
          icon={<LocalGasStationIcon />}
        />
        <SummaryItem
          title={summary.status}
          text={generalText.status[fuelTypeInformation.status]}
          icon={<CheckCircleIcon />}
        />
        {translations.length > 0 ? (
          <TranslationItem translations={fuelTypeInformation.translations} />
        ) : null}
      </SectionContainer>
    </Skeleton>
  )
}

export default Summary
